import Header from "./Headers";

import Config from '../config/config';
import Const from '../util/Constants';

class LiveLocationAPI {
  static list = (body, success, failure) => {
    fetch(Config.app.link + 'api/live-location-tracking/get', new Header('POST',body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
  export default LiveLocationAPI;